import { getCurrentInstance } from '@/util'

export default function useDi() {
  const instance = getCurrentInstance()
  const container = instance.proxy.$di
  return {
    container,
  }
}
